import React, { useState } from 'react'
import { AddObjectTypeComponent } from '../Components/ObjectType/AddObjectTypeComponent';
import { AllObjectTypeComponent } from '../Components/ObjectType/AllObjectTypeComponent';
import { EditObjectTypeComponent } from '../Components/ObjectType/EditObjectTypeComponent';
import { FieldComponent } from '../Components/Field/FieldComponent';
// ======================================================================
export const ObjectType = ({ setLoading, showMessage }) => {
    // ======================================================================
    const [view, setView] = useState('All');
    const [currentPage, setCurrentPage] = useState(1);
    const [version, setVersion] = useState(0);
    const [id, setId] = useState(0);
    // ======================================================================
    return (
        <>
            {view == "Child" ? (
                <FieldComponent
                    objectTypeId={id}
                    setLoading={setLoading}
                    showMessage={showMessage}
                    onBackClick={() => { setView("All") }}
                />
            ) : (view == "All" ?
                <AllObjectTypeComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    version={version}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    isShowInsert={true}
                    isShowEdit={true}
                    isShowDelete={true}
                    onAddClick={() => setView("Add")}
                    onEdit={(id) => { setId(id); setView("Edit") }}
                    onRowDeleted={() => { setVersion(version + 1); }}
                    onClickItem={(id) => { setId(id); setView("Child"); }}
                /> : (view === "Add" ? (
                    <AddObjectTypeComponent
                        setLoading={setLoading}
                        showMessage={showMessage}
                        rowInserted={() => {
                            setView("All"); if (currentPage != 1)
                                setCurrentPage(1);
                            else
                                setVersion(version + 1);
                        }}
                        cancelInsert={() => { setView("All"); }} />
                ) :
                    (
                        view === "Edit" ? (
                            <EditObjectTypeComponent
                                setLoading={setLoading}
                                showMessage={showMessage}
                                id={id}
                                rowUpdated={() => { setView("All"); setVersion(version + 1); }}
                                cancelEdit={() => { setView("All"); }} />
                        ) : (
                            <></>
                        )
                    ))
            )
            }

        </>

    )

}
